import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const UPDATE_PICKLIST_ITEMS_MUTATION = gql`
  mutation updatePicklistItems($items: [TBL_PICKLISTITEM_Input]) {
    updatePicklistItems(items: $items)
  }
`;

export default function usePicklistItemsUpdate() {
  const { mutate, loading, error } = useMutation(UPDATE_PICKLIST_ITEMS_MUTATION);

  async function updatePicklistItems(items) {
    try {
      const { data } = await mutate({ items });
      return data;
    } catch (error) {
      console.error('Error updating options:', error);
      addAlert('Error updating options', 'high', 4);
    }
  }

  return {
    updatePicklistItems,
    loading,
    error,
  };
}
